<template>
  <div>
    <q-page class="flex flex-center">
      <p v-if="!ready" class="text-faded">Loading...</p>
      <p v-else class="text-faded">{{ this.$route.params.id }}</p>
    </q-page>
  </div>
</template>

<script>
// nests accessed via /@nest_id
// format: nest_id supports alphanumeric including ".", "_", "-"
// purpose: list the widgets of channels associated to a nest id
// logic:
//   if nest id not found, suggest to create one (and an account)
//   if nest id found with 1 channel, auto redirect to that channel
//   if nest id found with 2+ channels, then list out the channel widgets
import { axiosLIO } from 'plugins/axios'

export default {
  name: 'PageNestChannels',
  data () {
    return {
      nestName: this.$route.params.id,
      ready: false,
    }
  },
  meta () {
    return {
      title: ['Wings', 'Nest', this.paramName].join(' · '),
      description: { name: 'description', content: 'Nests for ' + this.paramName }
    }
  },
  computed: {
    paramName () {
      return this.nestName
    }
  },
  beforeMount () {
    // query product information
    axiosLIO.get('/nest/' + this.nestName).then((res) => {
      console.log(res)
      try {
        let channels = res.data.data.channels
        if (channels && channels.length) {
          if (channels.length === 1) {
            // redirect
            setTimeout(() => {
              this.$router.push({ path: `/channel/${channels[0].uri}` })
            }, 400)
          } else {
            // render list instead
            this.ready = true
          }
        } else {
          this.goHome()
        }
      } catch (e) { this.goHome() }
    })
  },
  methods: {
    goHome () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
